"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _constants = require("composer-lib/lib/constants");

var _immutable = require("immutable");

var DEFAULTS = {
  status: _constants.RequestStatus.UNINITIALIZED,
  content: null,
  contentBeforeHighlighted: null,
  contentChanged: false,
  title: null,
  titleChanged: false,
  locked: false,
  lockedBy: null,
  lockVisible: false,
  highlighted: false,
  saveFailed: false,
  saveFailedModal: false,
  summary: null,
  summaryChanged: false,
  summaryHighlighted: false,
  titleHighlighted: false,
  readOnly: false,
  insertableLoading: false,
  clipLinkLoading: false,
  requiredScope: ''
};

var SaveState = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(SaveState, _Record);

  function SaveState() {
    (0, _classCallCheck2.default)(this, SaveState);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SaveState).apply(this, arguments));
  }

  (0, _createClass2.default)(SaveState, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new SaveState(data);
    }
  }]);
  return SaveState;
}((0, _immutable.Record)(DEFAULTS));

exports.default = SaveState;
module.exports = exports.default;